<template>
    <wrapper-edit
            :wrapper-width="wrapperWidth"
            class="edit"
            @back="paasPageBack">
        <Form ref="paasForm" slot="form"
              :model="paasFormData"
              :rules="paasFormRules"
              :label-width="defaultLabelWidth">
            <Row>
                <FormItem label="用户姓名:" prop="name" class="ivu-col-span-22">
                    <Input v-model="paasFormData.name" placeholder="用户姓名"></Input>
                </FormItem>
            </Row>
            <Row>
                <FormItem label="账号:" prop="accountLogin" class="ivu-col-span-22">
                    <Input v-model="paasFormData.accountLogin" placeholder="账号"></Input>
                </FormItem>
            </Row>
            <Row>
                <FormItem label="企业邮箱:" prop="email" class="ivu-col-span-22">
                <Input v-model="paasFormData.email" placeholder="企业邮箱"></Input>
                </FormItem>
            </Row>
            <Row>
                <FormItem label="状态:" prop="isDelete" class="ivu-col-span-22">
                    <Enum v-model="paasFormData.isDelete"  type="select"
                          :enumJsonKey="'base-accountStatus'"></Enum>
                </FormItem>
            </Row>
            <Row>
                <FormItem label="照片:" class="ivu-col-span-24">
                    <multiUploader
                            :fileList.sync="fileList"
                            :businessId="paasFormData.id"
                            :tempId="paasFormData.paasRepeatSubmitFlag"
                            uploadTitle="上传照片"
                            businessType="sysUser"
                            :single="false"
                            businessProperty="photo">

                    </multiUploader>
                </FormItem>
            </Row>
            <div class="edit-oper-toolbar">
                <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
                <mButton type="green" @click="paasFormSubmit('paasForm','','add')">继续添加</mButton>
                <mButton @click="paasPageBack">返回</mButton>
            </div>
        </Form>
    </wrapper-edit>
</template>

<script>
    import Enum from '@/components/paas/enum-form.vue';
    import FileUpload from '@/components/paas/file-upload.vue';
    import metaEdit from "@/assets/js/meta-edit.js";
    import wrapperEdit from "@/components/paas/wrapper-edit"
    import mButton from '@/components/button/m-button';
    import multiUploader from '@/components/paas/file/mult-uploader.vue'
    import $ from 'jquery';
    export default {
        mixins: [ metaEdit ],
        components: {Enum, FileUpload, wrapperEdit, mButton, multiUploader},
        data () {
            const paasValidUnique  = (rule, value, callback) => {
                if (value !== "" && value != null && value !== "null" && typeof value !== "undefined") {
                    let param = rule.param;
                    let formData = new FormData();
                    formData.append("query_EQ_" + rule.field, value);
                    if (param) {
                        for (let i = 0; i < param.length; i++) {
                            let propName = param[i];
                            let propNames = propName.split("_");
                            formData.append("", this.paasFormData[propNames[propNames.length - 1]]);
                            formData.append(propName, this.paasFormData[propNames[propNames.length - 1]]);
                        }
                    }
                    let errorInfo = "";
                    $.ajax({
                        url: rule.path,
                        type: "POST",
                        data: formData,
                        dataType: "json",
                        async: false,
                        timeout: 3000,
                        xhrFields: {
                            withCredentials: true
                        },
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            if (data.body.flag !== "true") {
                                errorInfo = "存在同名值";
                            }
                        },
                        error: ()=> {
                            errorInfo = "验证失败请重试！";
                        }
                    });
                    if (errorInfo) {
                        return callback(new Error(errorInfo));
                    }
                    else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            var validateEmail = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请正确填写邮箱'));
                } else {
                    if (value !== '') {
                    var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if (!reg.test(value)) {
                        callback(new Error('请输入有效的邮箱'));
                    }
                    }
                    callback();
                }
            };
            return {
                serviceUrl: "/sys/user",
                fileMultiple: false,
                fileList: [],
                uploadPath: this.$store.state.sysApi+"/sys/file/uploadFile",
                userPhotoParam: {fileBusinessType: 'sysUser', fileBusinessProp: 'photo', fileBusinessId: ''},
                paasFormData: {
                    id:"",
                    name:"",
                    email:"",
                    createTime:"",
                    updateTime:"",
                    createUserId:"",
                    createUserName:"",
                    isDelete:"",
                    paasRepeatSubmitFlag: '',
                    accountLogin: '',
                    password: '',
                    salt: '',
                    mobilePhone:""
                },
                paasFormRules: {
                    name: [
                        { required: true, trigger: 'blur' },
                        { type: 'string', trigger: 'blur', max: 20}
                    ],
                    email:[
                        { required: true, trigger: 'blur' },
                        {validator: validateEmail, trigger: 'blur'}

                        ],
                    accountLogin: [
                        { required: true, trigger: 'blur' },
                        /*{ validator: paasValidUnique, trigger: 'blur', path: this.$store.state.sysApi+'/sys/user/checkUnique', param: ['query_EQ_sysUserId'] },
                        /*{ type: 'numAlpha', trigger: 'blur', max: 20, min: 3}*/
                    ]
                },
                currentIdFiledName:'id',
                redirectName: 'sysUserList',
                nextAddName: 'sysUserEdit',
                wrapperWidth:'90%'
            }
        },
        methods: {
            createdCallback(data) {
                if(data.entity.photo !== null){
                    this.fileList.push(data.entity.photo);
                }
            },
        }
    }
</script>

<style scoped>
    .edit /deep/ .body{
        height: calc(100vh - 120px);
        overflow: auto;
    }
    .paas-viewer-img{
        width:100px;
    }

</style>
